import React, { Component } from 'react';
import { connect } from 'react-redux';
import DisqusThread from 'react-disqus-comments-sso';
import queryString from 'query-string';
import _ from 'lodash';
import PropTypes from 'prop-types';

class PopDisqusComments extends Component {
  handleNewComment(comment) {
    console.log(comment.text);
  }

  ssoConfig() {
    const baseUrl = window.location.origin;
    return {
      name: 'explore.org',
      button: 'https://explore.org/images/disqus-sso-login-button.png',
      icon: 'https://explore.org/images/favicon.png',
      url: `${baseUrl}/accounts/login/`,
      logout: `${baseUrl}/accounts/logout/`,
      width: '800',
      height: '400',
    };
  }

  render() {
    const { shortName, id, remoteAuthS3, isAuthenticated, url } = this.props;
    const queryParams = queryString.parse(_.get(location, 'search'));
    let disqusId = id;
    if(queryParams.disqus_identifier) {
      disqusId = queryParams.disqus_identifier;
    }
    const disqusComments = (isAuthenticated)
      ? (<DisqusThread
        shortname={shortName}
        identifier={disqusId}
        api_key={DISQUS_PUBLIC_KEY}
        remote_auth_s3={remoteAuthS3}
        onNewComment={this.handleNewComment}
        sso={this.ssoConfig()}
        url={url}
      />)
      : (<DisqusThread
        shortname={shortName}
        identifier={disqusId}
        onNewComment={this.handleNewComment}
        sso={this.ssoConfig()}
        url={url}
      />);
    return (
      <div style={{ backgroundColor: 'white', padding: '20px 30px' }}>{disqusComments}</div>
    );
  }
}

PopDisqusComments.defaultProps = {
  shortName: 'exploreorg',
  id: '',
  title: '',
  categoryId: '',
  remoteAuthS3: '',
  isAuthenticated: false,
};

PopDisqusComments.propTypes = {
  shortName: PropTypes.string,
  id: PropTypes.string,
  remoteAuthS3: PropTypes.string,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    id: state.currentItem.data.disqus_id,
    url: state.currentItem.data.disqus_url,
    remoteAuthS3: state.auth.disqus_sso,
    isAuthenticated: state.auth.isAuthenticated,
    commentsFullWidth: state.uiPreferences.commentsFullWidth,
  };
};

export default connect(mapStateToProps)(PopDisqusComments);
